var _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUserAvatarWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "no-user-avatar-web_svg__a",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 102.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 102.6,
    id: "no-user-avatar-web_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100c27.6 0 50-22.4 50-50S77.6 0 50 0 0 22.4 0 50s22.4 50 50 50z",
    fill: "#d9d9d9",
    filter: "url(#no-user-avatar-web_svg__a)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#no-user-avatar-web_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100c27.6 0 50-22.4 50-50S77.6 0 50 0 0 22.4 0 50s22.4 50 50 50z",
    fill: "#f1f3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 60.5c11.5 0 21.1-9.4 21.1-21.1 0-11.5-9.5-21.1-21.1-21.1-11.7 0-21.1 9.5-21.1 21.1 0 11.8 9.4 21.1 21.1 21.1zm8.2 7.9H41.6c-15.8 0-28.5 12.8-28.5 28.6 0 3.1 2.5 5.6 5.6 5.6H81c3.1 0 5.8-2.5 5.8-5.6 0-15.8-12.8-28.6-28.6-28.6z",
    fill: "#adb5bd"
  }))));
}
export default SvgNoUserAvatarWeb;